import { render, staticRenderFns } from "./MultipleChoice.vue?vue&type=template&id=4e0b12e1&scoped=true"
import script from "./MultipleChoice.vue?vue&type=script&lang=js"
export * from "./MultipleChoice.vue?vue&type=script&lang=js"
import style0 from "./MultipleChoice.vue?vue&type=style&index=0&id=4e0b12e1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e0b12e1",
  null
  
)

export default component.exports